import { useEffect, useState } from "react";
import logo from "../../../assets/haveto.svg";
import { ReactComponent as menuIcon } from "../../../assets/websiteIcon/Menu2.svg";
import { Button, Image, Space } from "antd";
import Icon, { CloseOutlined } from "@ant-design/icons";
import SignInForm from "../../User/SignInForm";
import { useAppDispatch } from "../../../store/hooks";
import { userActions } from "../../../store/user";
import { Link, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const [isMenuOpen, setisMenuOpen] = useState(false); // checking menu button is clicked or not in mobile view
  const [scroll, setScroll] = useState("");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const navigateToPath = (path: string) => {
    navigate(path);
  };

  // Scroll indicator code
  useEffect(() => {
    let progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight}`;

      setScroll(scroll);
    };
    window.addEventListener("scroll", progressBarHandler);
    return () => window.removeEventListener("scroll", progressBarHandler);
  });

  return (
    <>
      <SignInForm />
      {/* This div is for showing scrolling progress indicator */}
      <div id="progressBarContainer">
        <div id="progressBar" style={{ transform: `scale(${scroll}, 1)` }} />
      </div>
      <div className="home-back">
        <div className="header">
          <Link to={"/"}>
            <Image
              src={logo}
              preview={false}
              className="logo-img"
              onClick={() => {
                window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }}
            />
          </Link>
          {/* Start Navbar section for desktop */}
          <div className="navbar">
            <ul className="navbar-items">
              <li>
                <HashLink to={"/#features"}>Features</HashLink>
              </li>
              <li>
                <HashLink to={"/#roadmap"}>Roadmap</HashLink>
              </li>
              <li>
                <HashLink to={"/#coin-table"}>Coin Table</HashLink>
              </li>
              <li>
                <HashLink to={"/#about"}>About</HashLink>
              </li>
              <li>
                <Link to={"/leaderboard"}>Leaderboard</Link>
              </li>
              <li>
                <button
                  className="signin-button"
                  onClick={() =>
                    dispatch(userActions.signInModal({ visible: true }))
                  }
                >
                  Log In
                </button>
              </li>
              <li>
                <button
                  className="signup-button"
                  onClick={() =>
                    dispatch(userActions.signUpModal({ visible: true }))
                  }
                >
                  Sign Up
                </button>
              </li>
            </ul>
          </div>
          {/* Condition checking that mobile screen display menu icons and close icon */}
          <Button
            className="menu"
            onClick={() => setisMenuOpen(!isMenuOpen)}
            icon={
              isMenuOpen ? <CloseOutlined /> : <Icon component={menuIcon} />
            }
          />
        </div>
        {/* Start Navbar for mobile and tablet screen */}
        <div
          style={{ height: isMenuOpen ? "100%" : "0", zIndex: 4 }}
          className="overlay"
        >
          <div className="overlay-content">
            <Space direction={"vertical"}>
              <HashLink
                to={"/#features"}
                onClick={() => {
                  setisMenuOpen(false);
                }}
              >
                Features
              </HashLink>
              <HashLink
                to={"/#roadmap"}
                onClick={() => {
                  setisMenuOpen(false);
                }}
              >
                Roadmap
              </HashLink>
              <HashLink
                to={"/#coin-table"}
                onClick={() => {
                  setisMenuOpen(false);
                }}
              >
                Coin Table
              </HashLink>
              <HashLink
                to={"/#about"}
                onClick={() => {
                  setisMenuOpen(false);
                }}
              >
                About
              </HashLink>
              <a
                href="https://github.com/haveto/haveto-price-simulator"
                target="_blank"
              >
                Tokenomics Simulator
              </a>
              <a
                onClick={() => {
                  setisMenuOpen(false);
                  navigateToPath("/leaderboard");
                }}
              >
                Leaderboard
              </a>
              <button
                className="signin-button"
                onClick={() => {
                  setisMenuOpen(false);
                  dispatch(userActions.signInModal({ visible: true }));
                }}
              >
                Log In
              </button>
              <button
                className="signup-button"
                onClick={() =>
                  dispatch(userActions.signUpModal({ visible: true }))
                }
              >
                Sign Up
              </button>
            </Space>
          </div>
        </div>
        <div className="abs-height"></div>
      </div>
    </>
  );
};

export default Header;
